import { ReactFlowInstance, Node, Edge } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditDataResetNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditDataResetNode.id)) {
            newEdges.push(edge);
        }
    }
    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditDataResetNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: any[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }

    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

function getDataSlots(): { const: string, title: string }[] {
    return [
        { const: 'default', title: 'Default' },
        { const: 'data_one', title: 'Data One' },
        { const: 'data_two', title: 'Data Two' },
        { const: 'data_three', title: 'Data Three' },
        { const: 'data_four', title: 'Data Four' },
        { const: 'data_five', title: 'Data Five' },
        { const: 'data_six', title: 'Data Six' },
        { const: 'data_seven', title: 'Data Seven' },
        { const: 'data_eight', title: 'Data Eight' },
        { const: 'data_nine', title: 'Data Nine' },
        { const: 'data_ten', title: 'Data Ten' },
        { const: 'latest_user_message', title: 'Lastest User Message' },
    ];
}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
       reset_data: {
            title: 'Select Data',
            type: 'array',
            items: {
                title: 'Reset Slot',
                type: 'string',
                anyOf: getDataSlots()
            },
            description: "Each selected slow will be cleared of any value."
       },
    },
}

export const nodeDescription: string = "This node is used to reset a data slot.\n" +
    "If the slot is no longer needed, it can be cleared of any data to aid in memory management.\n";

